import React, { Component } from "react";
import DownloadResults from "./DownloadResults";
class PdfAnalyzeText extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rawText: [],
      forms: [],
      tables: [],
      messages: {
        receipt: (
          <div className="no-analysis">
            <p>Receipt Analysis is Not Enabled</p>
            <p>
              If PDF Document contains a Receipt : Enable Checkbox and Re-Upload
              Document
            </p>
          </div>
        ),
        forms: "",
        tables: "",
      },
      formsPair: '',
      tablesPair: '',
      summaryPair: '',
      itemsPair: '',
      rawJson: [],
    };
  }

  componentDidMount() {
    this.processPDFAnalyzeText(this.props.data, this.props.type);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data !== this.props.data ||
      prevProps.type !== this.props.type
    ) {
      this.processPDFAnalyzeText(this.props.data, this.props.type);
    }
  }

  processPDFAnalyzeText = (data, type) => {
    let parsedData = [];
    if (typeof data === "string") {
        try {
            parsedData = JSON.parse(data);
        } catch (err) {
            console.error("Failed to parse data:", err);
            parsedData = [];
        }
    } else if (Array.isArray(data)) {
        parsedData = data;
    }

    this.setState({ rawJson: parsedData });

    let response = parsedData;
      
    let rawText = [];
    let forms = [];
    let tables = [];
    let messages = { ...this.state.messages };
    let formsPair = "";
    let tablesPair = "";

    if (!response || response.length === 0) {
      rawText.push("No text was found");
      forms.push({ key: "N/A", value: "No forms were found" });
      tables.push("No tables were found");
      this.setState({ rawText, forms, tables, messages });
      return;
    }

    // block maps
    let key_map = {};
    let value_map = {};
    let block_map = {};
    let table_blocks = [];
    let table_blocks_map = {};

    response.forEach((page) => {
      page.forEach((block, i) => {
        if (block.BlockType === "LINE") {
          rawText.push({
            id: block.Id,
            text: block.Text,
            confidence: block.Confidence.toFixed(2),
          });
        }

        block_map[i] = block;
        table_blocks_map[block.Id] = block;

        if (block.BlockType === "KEY_VALUE_SET") {
          if (block.EntityTypes[0] === "KEY") {
            key_map[i] = block;
          } else {
            value_map[i] = block;
          }
        }

        if (block.BlockType === "TABLE") {
          table_blocks.push(block);
        }
      });
    });

    // Forms
    if (type === "form") {
      if (type === "form") {
        const key_value_pair = this.getKVRelationship(key_map, value_map, block_map);
        const keyData = Object.entries(key_value_pair);

        if (keyData.length === 0) {
          messages.forms = (
            <div className="no-analysis">
              <p>No Key - Pair values were found in the Document.</p>
            </div>
          );
        } else {
          forms = keyData.map(([key, value]) => ({ key, value }));

          for (let i = keyData.length - 1; i >= 0; i--) {
              formsPair += keyData[i][0] + "," + keyData[i][1] + "\n";
          }
        }
      } else {
        messages.forms = (
          <div className="no-analysis">
            <p>FORM Analysis is Not Enabled</p>
            <p>If PDF Document contains a FORM : Enable Form Analysis and Re-Upload PDF Document and Create a New Task</p>
          </div>
        );
      }
    }

    // Tables
    if (type === "table") {
      if (type === "table") {
        if (table_blocks.length === 0) {
          messages.tables = (
            <div className="no-analysis">
              <p>No Tables were found in the Document.</p>
            </div>
          );
        } else {
          tables = table_blocks.map((block, index) => {
              let result = this.generateTableCSV(block, table_blocks_map, index);

              tablesPair += this.generateTableString(block, table_blocks_map) + "\n\n";

              return result;
          });
        }
      } else {
        messages.tables = (
          <div className="no-analysis">
            <p>TABLE Analysis is Not Enabled</p>
            <p>If PDF Document contains a TABLE : Enable Document Analysis and Re-Upload PDF Document and Create a New Task</p>
          </div>
        );
      }
    }

    this.setState({ rawText, forms, tables, messages, formsPair, tablesPair });
  };

  generateTableString = (table_result, table_blocks_map) => {
      const rows = this.getRowsColumnsMap(table_result, table_blocks_map);
      const rowKeys = Object.keys(rows).sort((a, b) => Number(a) - Number(b));
      
      let table = "";
      rowKeys.forEach(rowKey => {
        const cols = rows[rowKey];
        const colKeys = Object.keys(cols).sort((a, b) => Number(a) - Number(b));
        const row = colKeys.map(colKey => `"${cols[colKey]}"`);
        table += row.join(",") + "\n";
      });

      return table;
  };

  /* --------------------------------------------------- */
  /*   GENERATE TABLE JSX
  /* --------------------------------------------------- */
  generateTableCSV = (table_result, table_blocks_map, table_index) => {
    const rows = this.getRowsColumnsMap(table_result, table_blocks_map);

    const rowKeys = Object.keys(rows).sort((a, b) => Number(a) - Number(b));

    return (
      <table key={table_index} className="table table-bordered my-3">
        <tbody>
          {rowKeys.map((rowKey, r) => {
            const cols = rows[rowKey];
            const colKeys = Object.keys(cols).sort(
              (a, b) => Number(a) - Number(b)
            );

            return (
              <tr key={r}>
                {colKeys.map((colKey, c) => (
                  <td key={c}>{cols[colKey]}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  getRowsColumnsMap(table_result, table_blocks_map) {
    const rows = {};

    if (table_result.Relationships) {
      const relationships = table_result.Relationships.filter(
        (rel) => rel.Type === "CHILD"
      );

      relationships.forEach((relationship) => {
        relationship.Ids.forEach((childId) => {
          const cell = table_blocks_map[childId];
          if (cell && cell.BlockType === "CELL") {
            const rowIndex = cell.RowIndex;
            const colIndex = cell.ColumnIndex;

            if (!rows[rowIndex]) rows[rowIndex] = {};
            rows[rowIndex][colIndex] = this.getTableText(
              cell,
              table_blocks_map
            );
          }
        });
      });
    }

    return rows;
  }

  getTableText(cell, table_blocks_map) {
    let text = "";

    if (cell.Relationships) {
      const childRel = cell.Relationships.find((rel) => rel.Type === "CHILD");

      if (childRel) {
        childRel.Ids.forEach((childId) => {
          const word = table_blocks_map[childId];
          if (word) {
            if (word.BlockType === "WORD") {
              text += word.Text + " ";
            }
            if (
              word.BlockType === "SELECTION_ELEMENT" &&
              word.SelectionStatus === "SELECTED"
            ) {
              text += "X ";
            }
          }
        });
      }
    }

    return text.trim();
  }

  getKVRelationship = (key_map, value_map, block_map) => {
    let kvs = {};
    for (let key_block in key_map) {
      const key_value = key_map[key_block];
      const value_block = this.findValueBlock(key_value, value_map);
      const key = this.getText(key_value, block_map);
      const val = this.getText(value_block, block_map);
      kvs[key] = val;
    }
    return kvs;
  };

  findValueBlock = (key_block, value_map) => {
    const key_data = Object.entries(key_block);
    const relationships = key_data[4];
    const relationship = relationships?.[1];
    let value_block = "";

    if (relationship && relationship[0]?.Type === "VALUE") {
      for (let [, value] of Object.entries(value_map)) {
        if (value.Id === relationship[0].Ids[0]) {
          value_block = value;
        }
      }
    }

    return value_block;
  };

  getText = (result, block_map) => {
    let text = "";
    if (!result) return text;

    const result_data = Object.entries(result);
    const block_map_data = Object.entries(block_map);
    const relationships = result_data[4];
    const relationship = relationships?.[1];

    // VALUE case
    if (result_data[5]?.[1][0] === "VALUE") {
      if (relationship?.[0]?.Type === "CHILD") {
        for (let child_id of relationship[0].Ids) {
          for (let [, block] of block_map_data) {
            if (block.Id === child_id) {
              if (block.BlockType === "WORD") {
                text += block.Text + " ";
              }
              if (
                block.BlockType === "SELECTION_ELEMENT" &&
                block.SelectionStatus === "SELECTED"
              ) {
                text += "X ";
              }
            }
          }
        }
      }
    }

    // KEY case
    if (result_data[5]?.[1][0] === "KEY") {
      if (relationship?.[1]?.Type === "CHILD") {
        for (let child_id of relationship[1].Ids) {
          for (let [, block] of block_map_data) {
            if (block.Id === child_id) {
              if (block.BlockType === "WORD") {
                text += block.Text + " ";
              }
              if (
                block.BlockType === "SELECTION_ELEMENT" &&
                block.SelectionStatus === "SELECTED"
              ) {
                text += "X ";
              }
            }
          }
        }
      }
    }

    return text;
  };

  render() {
    const { rawText, forms, tables, messages } = this.state;
    const { type } = this.props;

    return (
      <>
        {type === "text" && (
          <div id="raw-text">
            {rawText.map((line, i) =>
              typeof line === "string" ? (
                <div key={i}>{line}</div>
              ) : (
                <div key={line.id} className="text inline-text">
                  <span title={`Confidence: ${line.confidence}%`}>
                    {line.text}
                  </span>
                </div>
              )
            )}
          </div>
        )}

        {type === "form" && (
          <div id="forms">
            {messages.forms && <div>{messages.forms}</div>}
            {forms.length > 0 && (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Key</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {forms.map((row, i) => (
                    <tr key={i}>
                      <td>{row.key}</td>
                      <td>{row.value}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}

        {type === "table" && (
          <div id="tables">
            {messages.tables && <div>{messages.tables}</div>}
            {tables}
          </div>
        )}

        {type === "receipt" && (
          <div id="receipt">{messages.receipt}</div>
        )}
        <DownloadResults
            rawText={this.state.rawText}
            rawJson={this.state.rawJson}
            forms={this.state.formsPair}
            tables={this.state.tablesPair}
            items={this.state.itemsPair}
            summary={this.state.summaryPair}
        />
      </>
    );
  }
}

export default PdfAnalyzeText;